import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import type { ModuleKey } from '@six-pockets/shared';
import { useAuth } from '@/context/AuthContext';
import { BillsProvider } from '@/context/BillsContext';
import { TablesProvider } from '@/context/TablesContext';
import { ComingSoonPage } from '@/pages/ComingSoonPage';

/** Signed-in area. Data providers mount only after sign-in, so their first requests carry credentials. */
export function RequireAuth() {
  const { user, restoring } = useAuth();
  const location = useLocation();

  if (restoring) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;

  return (
    <TablesProvider>
      <BillsProvider>
        <Outlet />
      </BillsProvider>
    </TablesProvider>
  );
}

/** Shows the page only if the login has the module. The server checks the same access on every request. */
export function RequireModule({ module, children }: { module: ModuleKey; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(module)) return <ComingSoonPage title="No access" message="Your login doesn't have access to this section." />;
  return children;
}
